export interface IsNonEmptyHtmlOptions {
	tagNames?: string[];
}

const isNonEmptyHtmlElement = (
	element: Element,
	options?: IsNonEmptyHtmlOptions,
) => {
	const { tagNames = ['IMG', 'VIDEO', 'SVG', 'CANVAS'] } = options || {};
	if (element.textContent?.trim()) {
		return true;
	}
	if ([...element.children].some((el) => tagNames.includes(el.tagName))) {
		return true;
	}
	return [...element.children].some((el) => isNonEmptyHtmlElement(el, options));
};

export const isNonEmptyHtml = (htmlString: string) => {
	if (!htmlString) {
		return false;
	}
	const parser = new DOMParser();
	const doc = parser.parseFromString(htmlString, 'text/html');
	return isNonEmptyHtmlElement(doc.body);
};
